import { Modal } from '@mui/material';
import { MouseEvent, memo } from 'react';
import { faUsers } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  open: boolean;
  memberCount?: number;
  onConfirm: () => void;
  onCancel: () => void;
};

const bodyCopy = (memberCount?: number) =>
  memberCount
    ? `This will send a notification to all ${memberCount} members of this community.`
    : 'This will send a notification to all members of this community.';

export const MentionConfirmModal = memo(
  ({ open, memberCount, onConfirm, onCancel }: Props) => (
    <Modal open={open} onClose={onCancel}>
      <div
        onClick={(event: MouseEvent<HTMLDivElement>) => event.stopPropagation()}
        className="absolute left-1/2 top-1/2 w-[326px] -translate-x-1/2 -translate-y-1/2 rounded bg-white shadow-[0px_0px_1px_#EAECF0,0px_32px_64px_-12px_rgba(29,41,57,0.08)] md:w-[600px]"
      >
        <div className="flex items-center gap-2 p-8">
          <FontAwesomeIcon icon={faUsers} className="text-[#5F1ECC]" />
          <h4 className="text-xl font-bold">Notify all members?</h4>
        </div>
        <div className="flex px-8 py-2">
          <p>{bodyCopy(memberCount)}</p>
        </div>
        <div className="flex justify-end gap-4 p-8">
          <button
            type="button"
            onClick={onCancel}
            className="font-medium text-[#6B7280]"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="rounded bg-[#5F1ECC] px-4 py-2 font-medium text-white"
          >
            Send to all
          </button>
        </div>
      </div>
    </Modal>
  ),
);

MentionConfirmModal.displayName = 'MentionConfirmModal';
